// @flow

import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import IconButton from '../../../../components/IconButton';
import { download } from '../../../../utils/utils';
import storesApi from '../../../../network/api/storesApi';
import { notifyApolloError } from '../../../../network/notification';

type State = {
  isExcelLoading: boolean,
}

type Props = {
  dispatch: () => void,
  shoppingCenterName: string,
  pcId: number
}

class BestDealDownloadButton extends React.PureComponent<Props> {
  state: State = {
    isExcelLoading: false,
  }

  render() {
    return (
      <div className="btn-apollo-container">
        <IconButton
          icon="fal fa-file-download"
          className={`ripple-button ${this.state.isExcelLoading ? 'disabled' : ''} apollo-button-contained bestdeal-download-button`}
          isLoading={this.state.isExcelLoading}
          onClick={() => {
            this.setState({ isExcelLoading: true });
            storesApi.generateWeightedSpendReport(this.props.pcId)
              .then(excel => excel.blob())
              .then(responseBlob => download(
                responseBlob,
                I18n.t(
                  'bestDeals.report_filename',
                  { scName: this.props.shoppingCenterName },
                ),
              )).catch(e => this.props.dispatch(notifyApolloError(e)))
              .finally(() => this.setState({ isExcelLoading: false }));
          }}
        >
          <Translate value="bestDeals.report" />
        </IconButton>
      </div>
    );
  }
}

export default BestDealDownloadButton;
